const mediaItems = [
  {
    title: '《暗香》官方 PV',
    desc: '古风权谋巨制动画宣传片，感受摄政王与刺客少年的宿命对决。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20animation%20style%20scene%20atmospheric%20ancient%20Chinese%20palace%20with%20two%20male%20figures%20in%20flowing%20robes%20dramatic%20lighting%20moonlight%20through%20window%20golden%20and%20deep%20red%20color%20palette%20cinematic%20composition%20anime%20illustration%20quality&width=800&height=450&seq=media-manga-01&orientation=landscape',
    views: '128万',
  },
  {
    title: '《夜行》悬疑特辑',
    desc: '走进都市探案世界，与刑警队长和神秘法医一起揭开连环案件真相。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20mystery%20theme%20scene%20modern%20crime%20lab%20with%20two%20male%20anime%20characters%20examining%20evidence%20under%20blue%20lab%20lighting%20tense%20atmosphere%20glass%20boards%20with%20case%20notes%20detailed%20anime%20art%20style%20cinematic&width=800&height=450&seq=media-manga-02&orientation=landscape',
    views: '96万',
  },
  {
    title: '《青涩》名场面合集',
    desc: '校园青春最甜瞬间回顾，篮球场上与图书馆里的初恋心跳回忆。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20school%20romance%20scene%20sunset%20school%20courtyard%20two%20male%20anime%20teenagers%20sitting%20on%20bench%20under%20blooming%20cherry%20blossom%20tree%20warm%20golden%20evening%20light%20soft%20pastel%20colors%20gentle%20atmosphere%20anime%20illustration&width=800&height=450&seq=media-manga-03&orientation=landscape',
    views: '83万',
  },
  {
    title: '《星河》星际概念片',
    desc: '浩瀚宇宙中人类舰队首次接触外星文明，开启跨越星系的传奇旅程。',
    image: 'https://readdy.ai/api/search-image?query=Danmei%20manga%20sci-fi%20space%20scene%20massive%20futuristic%20spaceship%20bridge%20with%20two%20male%20anime%20characters%20gazing%20through%20panoramic%20window%20at%20colorful%20nebula%20and%20distant%20galaxy%20cool%20silver%20and%20indigo%20lighting%20grand%20scale&width=800&height=450&seq=media-manga-04&orientation=landscape',
    views: '74万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500">热门耽美漫画动画 PV 与精彩内容特辑</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <a key={idx} href="#media" className="group block">
              <div className="relative aspect-video rounded-lg overflow-hidden mb-3 bg-secondary-200">
                <img
                  src={item.image}
                  alt={`耽美漫画《${item.title}》视频封面`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-lg text-primary-600 group-hover:text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-[10px] px-1.5 py-0.5 bg-black/50 text-background-50 rounded">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}